/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import uuid from '@bingads-webui-component-legacy/uuid/index';
import * as _koSchemaString from '@bingads-webui-component-legacy/ko-schema-string/index';
var koSchemaString = _koSchemaString.default;
function ViewModel(options) {
  var self = this;
  var schema = options.schema;
  var placeholder = _.isFunction(options.placeholder) ? options.placeholder : _.constant(options.placeholder);
  function ItemViewModel(value) {
    this.value = koSchemaString(schema.items, value || '', options.customValidators);
    _.each(options.validatorMessages, function (message, name) {
      this.value.validators[name].set({
        message: message
      });
    }, this);
    this.placeholder = ko.observable('');
    this.hasFocus = ko.observable(false);
    this.id = options.id + '-' + uuid.v4();
  }
  ;
  self.items = ko.observableArray([]);
  self.items.subscribe(function (newValue) {
    _.each(self.items(), function (item, index) {
      item.placeholder(placeholder(index));
    });
  });
  self.items(_.map(options.values || [], function (item, index) {
    return new ItemViewModel(item);
  }));
  if (_.size(self.items()) < schema.minItems) {
    _.chain(_.range(schema.minItems - _.size(self.items()))).each(function () {
      return self.items.push(new ItemViewModel());
    });
  }
  self.isDeleteEnabled = ko.computed(function () {
    return schema.minItems <= 0 || _.size(self.items()) > schema.minItems;
  });
  self.isAddEnabled = ko.computed(function () {
    return schema.maxItems <= 0 || _.size(self.items()) < schema.maxItems;
  });
  self.values = ko.computed(function () {
    return _.chain(self.items()).pluck('value').map(function (value) {
      return value();
    }).value();
  });
  self.addItem = function () {
    if (!self.isAddEnabled()) {
      return;
    }
    self.items.push(new ItemViewModel());
  };
  self.deleteItem = function (item) {
    if (!self.isDeleteEnabled()) {
      return;
    }
    self.items.remove(item);
  };
}
export default ViewModel;

